/**
 * Dove tornare dopo l'accesso (24/09/2026). Prima si finiva sempre in chat,
 * anche partendo dalla postazione del banco o dal link della mail
 * «Vuole un tecnico»: la postazione Linux sempre accesa, al primo accesso,
 * si sarebbe ritrovata sulla chat. Solo percorsi interni: niente «//» (un
 * altro sito) e niente giri su /login.
 */
export function destinazioneDopoAccesso(stato: unknown): string {
  const da = (stato as { from?: unknown } | null)?.from;
  if (typeof da !== "string") return "/chat";
  if (!da.startsWith("/") || da.startsWith("//") || da.startsWith("/login")) return "/chat";
  return da;
}
